/*!
 * uncouple v0.4.0
 * (c) 2018-present Vitor Luiz Cavalcanti <vitorluizc@outlook.com> (https://vitorluizc.github.io)
 * Released under the MIT License.
 */
import reconstruct from 'reconstruct-descriptors';
/**
 * Check if property (key & descriptor) is a method.
 * @param name
 * @param descriptor
 */

var isMethod = function isMethod(name, ref) {
  var value = ref.value;
  return name !== 'constructor' && typeof name !== 'symbol' && typeof value === 'function';
};
/**
 * Uncouple object methods.
 * @example ```js
 * const { filter } = uncouple(Array.prototype);
 * filter([ 1, 2, 3, 4 ], (value) => value % 2 === 0);
 * //=> [ 2, 4 ]
 * ```
 * @param object - A prototype, namespace of object with methods.
 */


function uncouple(object) {
  return reconstruct(object, function (descriptor, name) {
    var obj;
    return isMethod(name, descriptor) && (obj = {}, obj[name] = {
      value: Function.call.bind(descriptor.value),
      writable: true,
      enumerable: true,
      configurable: true
    }, obj);
  });
}

export default uncouple;